<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-success btn-block">
        <li class="fa fa-recycle"></li> LIMPAR POSIÇOES ANTIGAS
    </button>
</template>
<script>
    import {Comandos} from "../../class/comandos";
    import {Bus} from '../../class/bus';
    export default {
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async reset () {
                await Comandos.limparPosicoesAntigas(this.id_rastreador);
                Bus.$emit('comandos');
            }
        }
    }
</script>
